module.exports = __webpack_public_path__ + "img/style.3c9b485b.png";